const Google = ({ size }: { size: number }) => (
  <svg
    width={size}
    height={size}
    viewBox={`0 0 ${size} ${size}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.28271 10.6416C5.61544 9.92102 6.04026 9.25621 6.53345 8.63905C8.79655 5.80709 11.7274 4.23118 15.3428 4.02993C18.5616 3.85078 21.4004 4.83672 23.8212 6.99811C23.9492 7.11227 23.9402 7.16879 23.8253 7.28325C22.7889 8.31564 21.757 9.35252 20.7296 10.3939C20.6245 10.5004 20.5724 10.4983 20.4629 10.3987C18.2993 8.43183 14.9856 8.13453 12.4171 9.68046C10.9083 10.5886 9.85864 11.8835 9.24906 13.5401C9.23259 13.5849 9.21165 13.6281 9.19281 13.6721C8.29871 12.9752 7.40549 12.2772 6.51021 11.582C6.10315 11.2658 5.69198 10.9549 5.28271 10.6416Z"
      fill="#E4391E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.8519 25.0949C23.3474 25.5986 22.7711 26.0083 22.163 26.3738C20.7083 27.2484 19.1239 27.733 17.4439 27.9167C15.5295 28.1259 13.6545 27.9515 11.8435 27.2745C8.92973 26.1852 6.75488 24.249 5.30156 21.4984C5.28489 21.4668 5.27329 21.4326 5.25928 21.3996C6.56099 20.3899 7.86264 19.3801 9.16435 18.3704C9.41381 19.036 9.7084 19.6804 10.1339 20.2531C11.8579 22.5735 14.1546 23.5846 17.0308 23.2527C18.1278 23.1261 19.1391 22.7556 20.0678 22.1586C20.7327 22.6772 21.3965 23.1971 22.0625 23.7141C22.6577 24.176 23.2553 24.6347 23.8519 25.0949Z"
      fill="#27A249"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.9026 25.016C23.3046 24.5568 22.7054 24.0991 22.1087 23.6381C21.4409 23.1221 20.7753 22.6033 20.1088 22.0857C20.6857 21.6653 21.2025 21.1858 21.6046 20.5912C22.0198 19.9771 22.301 19.3082 22.4633 18.5857C22.5005 18.42 22.4693 18.3847 22.3012 18.3851C20.2669 18.3905 18.2327 18.3886 16.1985 18.3886C15.9613 18.3886 15.9612 18.3886 15.9612 18.1618C15.9612 16.7526 15.9644 15.3434 15.957 13.9343C15.9561 13.7646 16.0069 13.7295 16.1681 13.7297C19.7912 13.7342 23.4143 13.734 27.0374 13.7304C27.1852 13.7302 27.2549 13.7549 27.2808 13.9221C27.7271 16.8158 27.425 19.6001 26.0623 22.2278C25.5415 23.2319 24.8618 24.1218 24.0413 24.9034C23.9983 24.9443 23.949 24.9786 23.9026 25.016Z"
      fill="#377CEE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.18364 18.3738C7.88364 19.385 6.58372 20.3963 5.28372 21.4075C4.85568 20.6031 4.55356 19.7509 4.34396 18.866C3.68841 16.0979 3.97218 13.4265 5.17585 10.8523C5.20595 10.788 5.24653 10.7285 5.28221 10.6667C5.69079 10.9791 6.10118 11.2891 6.50753 11.6044C7.40114 12.2977 8.29273 12.9936 9.18518 13.6885C9.0285 14.2298 8.89242 14.7745 8.84203 15.3389C8.75613 16.3006 8.84516 17.2426 9.12968 18.1655C9.15076 18.234 9.1658 18.3043 9.18364 18.3738Z"
      fill="#F1B300"
    />
  </svg>
);

export default Google;
